import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useHeroTitle } from "@hooks/useHeroTitle";
import cn from "classnames";
import { useDocument } from "@hooks/useDocument";
const PageH1 = ({ fallbackElement, forceFallback, className, ...rest }) => {
    const hasHeroTitle = useHeroTitle();
    const myDocument = useDocument();
    const Wrapper = useMemo(() => {
        if (!fallbackElement) {
            return "h1";
        }
        if (forceFallback && !!fallbackElement) {
            return fallbackElement;
        }
        else {
            return hasHeroTitle ? fallbackElement : "h1";
        }
    }, [hasHeroTitle, fallbackElement, forceFallback]);
    return _jsx(Wrapper, { className: cn(className, { invisible: !myDocument }), ...rest });
};
export default PageH1;
